import { gql } from "apollo-angular";

export const GET_ALL_TENANTS_SUBSCRIPTION = gql`
  subscription getAllTenants($userId: String!) {
    allTenants(userId: $userId) {
      data {
        id
        createdAt
        updatedAt
        code
        description
        isActive
        isDeleted
        logoUrl
        name
      }
      totalCount
    }
  }
`;

export const GET_ALL_TRIPS_SUBSCRIPTION = gql`
  subscription getAllTrips($userId: String!) {
    allTrips(userId: $userId) {
      data {
        id
        title
        description
        image
        category
        status
      }
      totalCount
    }
  }
`;

export const GET_ALL_TRIP_DATES_SUBSCRIPTION = gql`
  subscription getAllTripDates($tripId: String!) {
    allTripDates(tripId: $tripId) {
      data {
        id
        tripId
        startDate
        endDate
        price
        availableSeats
        status
        updatedAt
      }
      totalCount
    }
  }
`;

export const GET_ALL_BOOKINGS_SUBSCRIPTION = gql`
  subscription getAllBookings($userId: String!, $userFilter: BookingFilterDTOInput!) {
    allBookings(userId: $userId, userFilter: $userFilter) {
      data {
        id
        assignedTenantUserId
        assignedTenantUser {
          role
          user {
            id
            fullName
            profilePictureUrl
          }
        }
        userId
        user {
          id
          fullName
          profilePictureUrl
        }
        trip {
          id
          title
          description
        }
        totalAmount
        status
        paymentStatus
        participants {
          fullName
          email
          phoneNumber
        }
      }
      totalCount
    }
  }
`;

export const GET_ALL_USERS_SUBSCRIPTION = gql`
  subscription getAllUsers($userId: String!) {
    allUsers(userId: $userId) {
      data {
        id
        firstName
        lastName
        fullName
        email
        phoneNumber
        profilePictureUrl
        role
        isActive
        lastConnected
        loyaltyPoints {
          id
          value
          lastUpdated
          expiryDate
        }
        loyaltyCoins {
          id
          value
          lastUpdated
          expiryDate
        }
        currentLoyaltyLevel {
          id
          levelName
          code
          sortOrder
          isLocked
        }
      }
      totalCount
    }
  }
`;

export const GET_ALL_LOYALTY_TRANSACTIONS_SUBSCRIPTION = gql`
  subscription GetAllLoyaltyTransactions($userId: String!) {
    allLoyaltyTransactions(userId: $userId) {
      title
      message
      status
      method
      data {
        id
        userId
        points
        transactionType
        description
        transactionDate
        user {
          id
          fullName
          profilePictureUrl
          email
        }
      }
      totalCount
    }
  }
`;

export const GET_LOYALTY_STATS_SUBSCRIPTION = gql`
  subscription GetLoyaltyStats($userId: String!) {
    loyaltyStats(userId: $userId) {
      coins
      godchildren
      members
      exchanges
      won
      awards
    }
  }
`;

export const GET_ALL_REFERRALS = gql`
  subscription GetAllReferrals($userId: String!) {
    allReferrals(userId: $userId) {
      title
      message
      status
      method
      data {
        id
        createdAt
        updatedAt
        referrerId
        referrer {
          id
          firstName
          lastName
          fullName
          email
        }
        godChildrenId
        godChildren {
          id
          firstName
          lastName
          fullName
          email
        }
        transactions {
          id
          userId
          points
          transactionType
          description
          transactionDate
        }
        isProcessed
      }
      totalCount
    }
  }
`;

export const GET_REFERRAL_STATS = gql`
  subscription GetReferralStats($userId: String!) {
    referralStats(userId: $userId) {
      totalReferrals
      processedReferrals
      pendingReferrals
      totalPointsAwarded
      lastUpdated
    }
  }
`;

export const GET_PROGRAM_SUBSCRIPTION = gql`
  subscription GetProgram($userId: String!) {
    program(userId: $userId) {
      status
      title
      message
      totalCount
      data {
        id
        programName
        description
        pointsPerBooking
        pointsPerReview
        pointsPerReferral
        pointsValidityMonths
        enableLevels
        minPointsForReferralReward
        maxPointsPerTransaction
        createdAt
        updatedAt
        isDeleted
        levels {
          id
          levelName
          code
          requiredPoints
          pointsPerSpending
          referralBonusPoints
          sortOrder
          userCount
        }
      }
    }
  }
`;

export const GET_LOYALTY_STATISTICS_SUBSCRIPTION = gql`
  subscription GetLoyaltyStatistics($userId: String!) {
    getLoyaltyStatistics(userId: $userId) {
      totalUsers
      totalPointsEarned
      totalPointsRedeemed
      activePoints
      usersByLevel
      redemptionsByReward
      pointsEarnedBySource
    }
  }
`;

export const GET_ALL_LOYALTY_REDEMPTIONS_SUBSCRIPTION = gql`
  subscription GetAllLoyaltyRedemptions($userId: String!) {
    getAllLoyaltyRedemptions(userId: $userId) {
      status
      title
      message
      totalCount
      data {
        id
        userId
        userName
        pointsRedeemed
        rewardName
        rewardCode
        redemptionDate
        bookingId
        bookingReference
        createdAt
        updatedAt
        isDeleted
      }
    }
  }
`;

export const LOYALTY_GRAPHQL_TYPES = gql`
  input LoyaltyProgramFilterInput {
    page: Int!
    size: Int!
    programName: String
  }

  input LoyaltyRedemptionFilterInput {
    page: Int!
    size: Int!
    userId: String
    rewardName: String
    rewardCode: String
    dateFrom: DateTime
    dateTo: DateTime
  }

  input LoyaltyStatisticsFilterInput {
    startDate: DateTime
    endDate: DateTime
    programId: String
  }
`;
